import { WorkflowsCanvas } from "modules/workflows/components/Builder"

type Props = {
  campaignId: string
}

export function Workflow({ campaignId }: Props) {
  return (
    <div className="flex flex-1 flex-col min-h-[600px] rounded-lg border overflow-hidden">
      <WorkflowsCanvas campaignId={campaignId} />
    </div>
  )
}
